<template>
  <div class="pt-6 md:pt-0 relative overflow-x-auto">
    <Table :columns="tableColumns" :data="formattedData" is-accessible @view="retrieveChallengePerformances">
      <template #rewardStatus="{ row }">
        <div class="flex">
          <div class="rounded-lg">
            <span
              :class="[
                'inline-block items-center px-3 py-0.5 mt-1 rounded-full text-xs font-medium',
                rewardStatusClasses(row.rewardStatus),
              ]"
            >
              {{ $t(`challenge.reward_status.${row.rewardStatus}`) }}
            </span>
          </div>
        </div>
      </template>
    </Table>
  </div>
  <Modal :size="'big'" :open="openModal" @close="openModal = false">
    <ChallengePerformances :challenge="challenge" :performance="performance" />
  </Modal>
</template>

<script>
import { Table } from "@estaly/ui";
import { toCamelCase } from "@estaly/ui/src/utils/data_formatter";
import { Modal } from "@estaly/ui";
import ChallengePerformances from "@/components/challenge/ChallengePerformances.vue";

import StoreService from "@/api/services/store";

export default {
  components: { Table, Modal, ChallengePerformances },
  props: ["challenges", "storeId"],
  data() {
    return {
      openModal: false,
      challenge: {},
      performance: {},
    };
  },
  computed: {
    tableColumns() {
      return [
        { field: "title", label: "Nom" },
        { field: "startDate", label: "Début" },
        { field: "endDate", label: "Fin" },
        { field: "rewardStatus", label: "Statut des gains", slot: "rewardStatus" },
      ];
    },
    formattedData() {
      return this.challenges.map((challenge) => ({
        id: challenge.id,
        title: challenge.title,
        startDate: challenge.startDate,
        endDate: challenge.endDate,
        rewardStatus: challenge.rewardStatus,
      }));
    },
  },
  methods: {
    async retrieveChallengePerformances(challenge) {
      const response = await StoreService.getChallengesAndSellersPerformance(this.storeId, challenge.id);
      if (response?.success) {
        const data = toCamelCase(response.data);
        this.challenge = data.challenge;
        this.performance = data.performance;
        this.openModal = true;
      }
    },
    rewardStatusClasses(status) {
      if (status == "activated") return "bg-green-100 text-green-800";
      if (status == "sent") return "bg-blue-100 text-blue-800";
      return "bg-yellow-100 text-yellow-800";
    },
  },
};
</script>
